export default __webpack_public_path__ + "static/media/fundraising_main.74f639fa.png";